import { render, staticRenderFns } from "./info-check-in-comment.vue?vue&type=template&id=19fc2ba6&scoped=true&"
import script from "./info-check-in-comment.vue?vue&type=script&lang=js&"
export * from "./info-check-in-comment.vue?vue&type=script&lang=js&"
import style0 from "./info-check-in-comment.vue?vue&type=style&index=0&id=19fc2ba6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fc2ba6",
  null
  
)

export default component.exports